/**
 * Polyfills for older iOS Safari versions (iOS < 14.5, Safari < 13.7)
 * These ensure compatibility with devices that don't support newer JavaScript features
 */

// String.prototype.replaceAll polyfill
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replace) {
    if (search instanceof RegExp) {
      return this.replace(search, replace);
    }
    return this.replace(new RegExp(search, "g"), replace);
  };
}

// Array.prototype.at polyfill (for potential future use)
if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    const length = this.length;
    const k = index >= 0 ? index : length + index;
    if (k < 0 || k >= length) {
      return undefined;
    }
    return this[k];
  };
}

// Promise.allSettled polyfill (for potential future use)
if (!Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map((promise) =>
        Promise.resolve(promise).then(
          (value) => ({ status: "fulfilled", value }),
          (reason) => ({ status: "rejected", reason }),
        ),
      ),
    );
  };
}

// Object.fromEntries polyfill (for potential future use)
if (!Object.fromEntries) {
  Object.fromEntries = function (entries) {
    const obj = {};
    for (const [key, value] of entries) {
      obj[key] = value;
    }
    return obj;
  };
}

export default {};
